export type Country = {
  id: string;
  name: string;
};

export const countriesList: Country[] = [
  { id: "AG", name: "Antigua and Barbuda" },
  { id: "AR", name: "Argentina" },
  { id: "AU", name: "Australia" },
  { id: "AT", name: "Austria" },
  { id: "BB", name: "Barbados" },
  { id: "BE", name: "Belgium" },
  { id: "BR", name: "Brazil" },
  { id: "BG", name: "Bulgaria" },
  { id: "CA", name: "Canada" },
  { id: "CL", name: "Chile" },
  { id: "CN", name: "China" },
  { id: "CO", name: "Colombia" },
  { id: "CR", name: "Costa Rica" },
  { id: "CY", name: "Cyprus" },
  { id: "CZ", name: "Czech Republic" },
  { id: "DK", name: "Denmark" },
  { id: "EU", name: "Europe" },
  { id: "FI", name: "Finland" },
  { id: "FR", name: "France" },
  { id: "DE", name: "Germany" },
  { id: "WO", name: "Global" },
  { id: "GR", name: "Greece" },
  { id: "GN", name: "Guinea" },
  { id: "GY", name: "Guyana" },
  { id: "HK", name: "Hong Kong" },
  { id: "HU", name: "Hungary" },
  { id: "IS", name: "Iceland" },
  { id: "IN", name: "India" },
  { id: "ID", name: "Indonesia" },
  { id: "IE", name: "Ireland" },
  { id: "IM", name: "Isle of Man" },
  { id: "IL", name: "Israel" },
  { id: "IT", name: "Italy" },
  { id: "JP", name: "Japan" },
  { id: "KR", name: "Korea (Republic of)" },
  { id: "LU", name: "Luxembourg" },
  { id: "MY", name: "Malaysia" },
  { id: "MX", name: "Mexico" },
  { id: "MM", name: "Myanmar" },
  { id: "NA", name: "Namibia" },
  { id: "NL", name: "Netherlands" },
  { id: "NZ", name: "New Zealand" },
  { id: "NO", name: "Norway" },
  { id: "PE", name: "Peru" },
  { id: "PH", name: "Philippines" },
  { id: "PL", name: "Poland" },
  { id: "PT", name: "Portugal" },
  { id: "RO", name: "Romania" },
  { id: "RU", name: "Russian Federation" },
  { id: "SM", name: "San Marino" },
  { id: "SN", name: "Senegal" },
  { id: "SL", name: "Sierra Leone" },
  { id: "SG", name: "Singapore" },
  { id: "ZA", name: "South Africa" },
  { id: "SS", name: "South Sudan" },
  { id: "ES", name: "Spain" },
  { id: "SD", name: "Sudan" },
  { id: "SR", name: "Suriname" },
  { id: "SE", name: "Sweden" },
  { id: "CH", name: "Switzerland" },
  { id: "TW", name: "Taiwan" },
  { id: "TH", name: "Thailand" },
  { id: "TR", name: "Turkey" },
  { id: "UA", name: "Ukraine" },
  { id: "GB", name: "United Kingdom" },
  { id: "US", name: "United States of America" },
  { id: "VN", name: "Vietnam" },
];

export const countryDisplayLabels: Record<string, string> = {
  AG: "Antiguan",
  AR: "Argentine",
  AU: "Australian",
  AT: "Austrian",
  BB: "Barbadian",
  BE: "Belgian",
  BR: "Brazilian",
  BG: "Bulgarian",
  CA: "Canadian",
  CL: "Chilean",
  CN: "Chinese",
  CO: "Colombian",
  CR: "Costa Rican",
  CY: "Cypriot",
  CZ: "Czech",
  DK: "Danish",
  EU: "EU",
  FI: "Finnish",
  FR: "French",
  DE: "German",
  WO: "Global",
  GR: "Greek",
  GN: "Guinean",
  GY: "Guyanese",
  HK: "Hong Kong",
  HU: "Hungarian",
  IS: "Icelandic",
  IN: "Indian",
  ID: "Indonesian",
  IE: "Irish",
  IM: "Manx",
  IL: "Israeli",
  IT: "Italian",
  JP: "Japanese",
  KR: "South Korean",
  LU: "Luxembourg",
  MY: "Malaysian",
  MX: "Mexican",
  MM: "Myanmar",
  NA: "Namibian",
  NL: "Dutch",
  NZ: "New Zealand",
  NO: "Norwegian",
  PE: "Peruvian",
  PH: "Philippine",
  PL: "Polish",
  PT: "Portuguese",
  RO: "Romanian",
  RU: "Russian",
  SM: "Sammarinese",
  SN: "Senegalese",
  SL: "Sierra Leonean",
  SG: "Singaporean",
  ZA: "South African",
  SS: "South Sudanese",
  ES: "Spanish",
  SD: "Sudanese",
  SR: "Surinamese",
  SE: "Swedish",
  CH: "Swiss",
  TW: "Taiwanese",
  TH: "Thai",
  TR: "Turkish",
  UA: "Ukrainian",
  GB: "UK",
  US: "US",
  VN: "Vietnamese",
};

export function getCountryDisplayLabel(
  code: string | undefined | null
): string {
  if (!code) return "";
  return (
    countryDisplayLabels[code] ??
    countriesList.find((c) => c.id === code)?.name ??
    code
  );
}
